import React from "react"
import strings from "../../../localization/strings"
import autobind from "class-autobind"
import { FloatingActionButton, Dialog, FlatButton, Table, TableHeader, TableHeaderColumn, TableBody, TableRow, TableRowColumn } from "material-ui"
import { ELanguage, IAgreement, IPrivacyAgreementDocument } from "../../../models"
import _ from "lodash"
import AppStateStore from "../../../stores/AppStateStore"
import AddAgreementTextDialog from "./AddAgreementTextDialog"
import EditIcon from "material-ui/svg-icons/image/edit"
import DeleteIcon from "material-ui/svg-icons/action/delete"
import { EnumValues } from "enum-values"
import ContentAdd from "material-ui/svg-icons/content/add"

interface IProps {
    latestAgreement: IPrivacyAgreementDocument
    handleClose(): void
    handleCreate(newAgreement: IPrivacyAgreementDocument): void
    handleUpdate(latestAgreement: IPrivacyAgreementDocument): void
}
interface IState {
    agreements: IAgreement[]
    errorAgreements: string
    openAddAgreementTextDialog: boolean
    editAgreement: IAgreement
}

export default class AddAgreementDialog extends React.Component<IProps, IState> {
    constructor(props: IProps) {
        super(props)
        this.state = {
            agreements: this.props.latestAgreement && this.props.latestAgreement.Agreements ? this.props.latestAgreement.Agreements : [],
            errorAgreements: "",
            openAddAgreementTextDialog: false,
            editAgreement: null
        }
        autobind(this)
    }

    checkValidate() {
        let isValidate = true
        if (this.state.agreements.length === 0) {
            this.setState({ errorAgreements: strings.Agreement_is_empty })
            isValidate = false
        }
        else {
            const engAgreement = this.state.agreements.find(i => i.Language === ELanguage.English)
            if (!engAgreement) {
                this.setState({ errorAgreements: strings.English_agreement_is_required_by_default })
                isValidate = false
            }
            else {
                this.setState({ errorAgreements: "" })
            }
        }
        return isValidate
    }

    render() {
        return (
            <Dialog
                open
                autoScrollBodyContent
                title={strings.Agreement}
                actions={[
                    <span style={{ fontSize: 19, marginRight: 75, color: "#F57C00" }}>
                        {this.state.errorAgreements}
                    </span>,
                    <FlatButton
                        data-intercom-target={"AgreementDialog-Btn-Close"}
                        label={strings.CANCEL}
                        secondary
                        onTouchTap={this.props.handleClose}
                    />,
                    this.props.latestAgreement &&
                    <FlatButton
                        data-intercom-target={"AgreementDialog-Btn-Update"}
                        label={strings.Update}
                        primary
                        onTouchTap={() => {
                            if (!this.checkValidate()) return
                            const latestAgreement = _.cloneDeep(this.props.latestAgreement)
                            latestAgreement.Agreements = this.state.agreements
                            this.props.handleUpdate(latestAgreement)
                        }}
                    />,
                    <FlatButton
                        data-intercom-target={"AgreementDialog-Btn-Create"}
                        label={strings.Create}
                        primary
                        onTouchTap={() =>
                            this.checkValidate() &&
                            AppStateStore.setConfirmDialogContent({
                                content: strings.Are_you_sure_you_want_to_create_new_version_agreement,
                                confirm: () => {
                                    this.props.handleCreate({ Agreements: this.state.agreements } as IPrivacyAgreementDocument)
                                }
                            })}
                    />
                ]}
            >
                <div style={{ position: "relative" }}>
                    <FloatingActionButton
                        data-intercom-target={"Add-Agreement-Btn"}
                        className="fixed-add"
                        style={{ top: 0, right: 20 }}
                        mini
                        secondary
                        onTouchTap={() => this.setState({ openAddAgreementTextDialog: true })}
                    >
                        <ContentAdd />
                    </FloatingActionButton>
                    <Table>
                        <TableHeader
                            displaySelectAll={false}
                            adjustForCheckbox={false}
                        >
                            <TableRow>
                                <TableHeaderColumn style={{ textAlign: "left" }}>{strings.Language}</TableHeaderColumn>
                                <TableHeaderColumn style={{ width: 50 }} />
                            </TableRow>
                        </TableHeader>
                        <TableBody displayRowCheckbox={false}>
                            {this.state.agreements.map(agreement =>
                                <TableRow key={agreement.Language}>
                                    <TableRowColumn style={{ textAlign: "left" }}>{EnumValues.getNameFromValue(ELanguage, agreement.Language)}</TableRowColumn>
                                    <TableRowColumn style={{ width: 50 }}>
                                        <EditIcon
                                            onClick={() => this.setState({ editAgreement: agreement, openAddAgreementTextDialog: true })}
                                        />
                                        <DeleteIcon
                                            onClick={() => AppStateStore.setConfirmDialogContent({
                                                content: strings.Are_you_sure_you_want_to_delete_this_language_agreement,
                                                confirm: () =>
                                                    this.setState({ agreements: this.state.agreements.filter(i => i.Language !== agreement.Language) }, () => this.checkValidate())
                                            })}
                                        />
                                    </TableRowColumn>
                                </TableRow>
                            )}
                        </TableBody>
                    </Table>
                </div>
                {this.state.openAddAgreementTextDialog &&
                    <AddAgreementTextDialog
                        existingLanguages={this.state.agreements.map(i => i.Language)}
                        editAgreement={this.state.editAgreement}
                        handleClose={() => this.setState({ openAddAgreementTextDialog: false })}
                        handleSave={agreement => {
                            const agreements = _.cloneDeep(this.state.agreements)
                            const indexOf = agreements.findIndex(i => i.Language === agreement.Language)
                            if (indexOf > -1) {
                                agreements[indexOf] = agreement
                            }
                            else {
                                agreements.push(agreement)
                            }
                            this.setState({ agreements, openAddAgreementTextDialog: false }, () => this.checkValidate())
                        }}
                    />
                }
            </Dialog>
        )
    }
}